import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

import { FormContext } from '../../../../hooks/useForm';
import FormWrapper from '../../../FormWrapper';

const ZONAL_TYPES = {
  content: [{ id: 0 }],
  loading: false,
  error: false,
};

const Zonal = ({ path, disabled = false }) => {
  const { t } = useTranslation();
  const form = useContext(FormContext);

  const { input, select } = form;

  const value1Field = select(`${path}.value1`);

  return (
    <Row gutter={16}>
      <Col xs={24} sm={24} md={8} lg={6} xl={6}>
        <FormWrapper.Select
          label={t('entity.offers.restrictions.restriction.ZONAL.type')}
          props={{
            options: ZONAL_TYPES.content,
            loading: ZONAL_TYPES.loading,
            ...value1Field,
            labelProp: (val) =>
              t(`entity.offers.restrictions.restriction.ZONAL.types.${val.id}`),
            onChange: (val) => {
              // keep form state updated
              value1Field.onChange(val);
            },
          }}
        />
      </Col>

      <Col xs={24} sm={24} md={8} lg={6} xl={6}>
        <FormWrapper.Number
          label={t('entity.offers.restrictions.restriction.ZONAL.transitions')}
          props={{
            min: 0,
            max: 2,
            step: 1,
            ...input(`${path}.value2`),
            disabled,
          }}
        />
      </Col>
    </Row>
  );
};

export default Zonal;
